import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useMonthlyPaymentContractStyles = makeStyles({
    simpleLineCardWrapper: {
        ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingVerticalNone)
    },
    checkbox: {
        marginBottom: tokens.spacingVerticalS,
        width: '100%'
    },
    contractLink: {
        color: tokens.colorBrandForegroundLink
    },
    agreeButton: {
        width: '190px',
        height: '40px'
    },
    pdfContainer: {
        display: 'flex'
    },
    pdfThumbnail: {
        height: '100px',
        ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
        ...shorthands.borderRadius('6px'),
        marginRight: tokens.spacingHorizontalS,
        cursor: 'pointer'
    },
    pdfIconLink: {
        height: '14px',
        color: tokens.colorNeutralStroke1,
        cursor: 'pointer'
    }
});

export default useMonthlyPaymentContractStyles;
